import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Teacher {
    teacher_id:number | null;
    name:string | null;
    uid:string | null;
    email:string | null;
    joined_at:string | null;
    ai_avatar:string | null;
}
interface Student {
    student_id: number | null;
    name: string | null;
    uid: string | null;
    email: string | null;
    joined_at: string | null;
    ai_avatar: string | null;
  }
interface LetestTeacher {
    teachers:Teacher[];
    students: Student[];
    count:number | null;
    next:string | null;
    previous:string | null;
    isLoading: boolean;
    error: string | null;
    totalPages: number | null;
}

const initialState : LetestTeacher = {
    teachers:[],
    students: [],
    next: null,
    previous: null,
    count: 0,
    totalPages: 0,
    isLoading: false,
    error: null,
}

const LetestTeacherslice = createSlice({
    name: "letestteacherlist",
    initialState,
    reducers: {
       
        setLetestTeacherlist: (state: LetestTeacher, action: PayloadAction<Teacher[]>) => {
            
            state.teachers = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setStudentBySchool: (state: LetestTeacher, action: PayloadAction<Student[]>) => {
            
            state.students = action.payload;
            state.isLoading = false;
            state.error = null;
        },
        setPagination: (state: LetestTeacher, action: PayloadAction<LetestTeacher>) => {
            state.next = action.payload.next;
            state.previous = action.payload.previous;
            state.count = action.payload.count;
            state.totalPages = Math.ceil((action.payload.count ?? 0) / 12);
            state.isLoading = false;
            state.error = null;
        },  
        setloading: (state: LetestTeacher, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            state.error = null; 
        },
        seterror: (state : LetestTeacher, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        resetLetestTeacher: () => {
            return initialState;
        },
    },

});

export const {resetLetestTeacher, setLetestTeacherlist,setStudentBySchool , seterror, setloading} = LetestTeacherslice.actions;

export default LetestTeacherslice.reducer;